import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import AddButton from '../../components/buttons/addButton';

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import { isActiveFormatter, isMultiplyFormatter, isMultiplyTextFormatter, isActiveTextFormatter } from '../../components/formatters/defFormatter';
import { DataContext } from '../../init/getData';




function Currency(props) {

  let { } = props;


  const { userData, settingData, companyId, api } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);


  const [name, setName] = useState('');
  const [currency, setCurrency] = useState([]);

  const table = 'currency';
  const title = 'Currency';


  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const resetForm = () => {
    setCurrency({ name: '' });
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  // idRow Change
  useEffect(() => {
    setCurrency(
      {
        companyId: companyId,
        name: idRow?.name || '',
        code: idRow?.code || '',
        symbol: idRow?.symbol || '',
        rate: idRow?.rate || '',
        isMultiply: idRow?.isMultiply || false,
      }
    )
  }, [idRow]);


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }
    setCurrency((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        ID: item.id,
    Name: item.name,
    Code: item.code,
    Symbol: item.symbol,
    Rate: item.rate,
    Equation: isMultiplyTextFormatter(item.isMultiply),
    Status: isActiveTextFormatter(item.isActive),
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };



  let newColumnDefs = [
    { title: 'ID', dataIndex: 'id', width: '5%', sorter: (a, b) => a.age - b.age },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Code', dataIndex: 'code' },
    { title: 'Symbol', dataIndex: 'symbol' },
    { title: 'Rate', dataIndex: 'rate' },
    { title: 'Equation', dataIndex: 'isMultiply', render: isMultiplyFormatter },
    { title: 'Status', dataIndex: 'isActive', render: isActiveFormatter },
  ];

  useEffect(() => {

    newColumnDefs.push(
      {
        title: 'Edt',
        width: '5%',
        render: (_, record) => (
          <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
        ),
      },
      {
        title: 'Void',
        width: '5%',
        render: (_, record) => (record.isActive ? (
          <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
        ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
        )
      }
    );

    setColumnDefs(newColumnDefs);

  }, []);


  const typeOptions = [
    { value: true, label: 'Multiply' },
    { value: false, label: 'Divide' },
  ];

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setCurrency((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }

  const formView = (
    <div style={{ userSelect: 'none' }}>


      <Row className="mb-3">

        {/* Name  */}
        <Col>
          <Form.Label>Name<span style={{ color: 'red' }}> *</span></Form.Label>
          <Form.Control type="text" name='name'
            value={currency?.name}
            onChange={handleInputChange}
            required
          />
        </Col>
      </Row>


      <Row className="mb-3">

        {/* Code  */}
        <Col>
          <Form.Label>Code<span style={{ color: 'red' }}> *</span></Form.Label>
          <Form.Control type="text" name='code'
            value={currency?.code}
            onChange={handleInputChange}
            required
          />
        </Col>

        {/* Symbol  */}
        <Col>
          <Form.Label>Symbol<span style={{ color: 'red' }}> *</span></Form.Label>
          <Form.Control type="text" name='symbol'
            value={currency?.symbol}
            onChange={handleInputChange}
            required
          />
        </Col>
      </Row>



      <Row className="mb-3">

      </Row>


      <Row className="mb-3">
        {/* Rate  */}
        <Col>
          <Form.Label>Rate<span style={{ color: 'red' }}> *</span></Form.Label>
          <Form.Control type="number" name='rate'
            value={currency?.rate}
            onChange={handleInputChange}
            required
          />
        </Col>

        <Col>
          <Form.Label>Type</Form.Label>
          <Select
            options={typeOptions}
            isSearchable={true}
            placeholder="Select"
            onChange={(e) => handleSelectChange(e, 'isMultiply')}
            value={typeOptions?.find(option => option.value === currency.isMultiply) || []}
            required
          />
        </Col>
      </Row>


    </div >);




  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <></>
  );


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <Row className='g-0 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={8}>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
              <Button
                style={{ backgroundColor: '#23576a', color: 'white' }}
                onClick={() => addModal(null)} >Add</Button>
            </Col>

          </Row>



          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow.id }}
          />


          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id }}
          />

          <AddModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ currency }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'md'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, currency }}
          />


        </>
      }

    </div>
  )
}

export default Currency;
